import { createFileRoute } from "@tanstack/react-router"
import { Suspense } from "react"
import { TripPage } from "@/components/pages/TripPage/lazy"
import { NotFound } from "@/components/NotFound"
import { useCanonicalId } from "@/lib/hooks/use-canonical-id"

function TripPageRoute() {
  const { tripId: param } = Route.useParams()
  // New links carry a short id, old links a uuid — resolve to the canonical
  // uuid here so cache keys/broadcast channels/chat targets stay uuid-based.
  const tripId = useCanonicalId(`trip`, param)
  if (tripId === undefined) return null
  if (tripId === null) return <NotFound />
  // TripPage is lazy (see lazy.ts) — Suspense covers the chunk fetch. It has its
  // own loading UI once mounted, so a null fallback is enough for the brief gap.
  return (
    <Suspense fallback={null}>
      <TripPage readOnly={false} tripId={tripId} />
    </Suspense>
  )
}

// Trip data loads via tRPC/React Query (useTripData) on mount.
export const Route = createFileRoute(`/_authenticated/trip/$slug/$tripId/`)({
  component: TripPageRoute,
  ssr: false,
})
